import * as moment from "moment";

export enum DateRanges {
    CurrentMonth = "CurrentMonth",
    LastMonth = "LastMonth",
    LastQuarter = "LastQuarter",
    CurrentWeek = "CurrentWeek",
    LastWeek = "LastWeek"
}

export interface DateRangeData {
    DateFrom: Date;
    DateTo: Date;
}

export type DateRangeType = {
    [key: string]: DateRangeData;
};

export function GetDateRange(type: DateRanges): DateRangeData {
    let DateFrom = new Date();
    let DateTo = new Date();
    let CurrentDate = new Date();
    switch (type) {
        case DateRanges.CurrentMonth:
            DateFrom = moment.utc(CurrentDate).startOf("month").toDate();
            DateTo = moment.utc(CurrentDate).endOf("month").toDate();
            break;
        case DateRanges.LastMonth:
            const LastMonth = new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), 0);
            DateFrom = moment.utc(LastMonth).startOf("month").toDate();
            DateTo = moment.utc(LastMonth).endOf("month").toDate();
            break;
        case DateRanges.CurrentWeek:
            DateFrom = moment.utc(CurrentDate).startOf("week").toDate();
            DateTo = moment.utc(CurrentDate).endOf("week").toDate();
            break;
        case DateRanges.LastWeek:
            const LastWeek = moment.utc(CurrentDate).subtract(7, "days").toDate();
            DateFrom = moment.utc(LastWeek).startOf("week").toDate();
            DateTo = moment.utc(LastWeek).endOf("week").toDate();
            break;
        case DateRanges.LastQuarter:
            const QuarterNumber = moment(CurrentDate).quarter() - 1;
            DateFrom = moment().quarter(QuarterNumber).startOf("quarter").toDate();
            DateFrom = new Date(DateFrom.getFullYear(), DateFrom.getMonth(), 2);
            DateFrom = moment.utc(DateFrom).startOf("month").toDate();
            DateTo = moment().quarter(QuarterNumber).endOf("quarter").toDate();
            break;
    }
    return { DateFrom: DateFrom, DateTo: DateTo };
}



// WEBPACK FOOTER //
// ./src/helpers/DateHelper.ts